import React, { Key, ReactNode } from "react"
import { StyleVariants } from "../../state/sharedTypes"
import Button from "../buttons/Button"

interface IPropsFromParent {
  pageTitle: string
  buttonText?: string
  buttonHref?: string
  hasButtonPermission?: boolean
  secondaryButton?: ReactNode
}

type Props = IPropsFromParent

export const TitleButtonFactory = (action: string | VoidFunction, text: ReactNode, key: Key): JSX.Element => {
  if (typeof action == "string")
    return (
      <Button
        href={action as string}
        className="ml-5"
        variant={StyleVariants.ORANGE}
        key={key}
      >
        {text}
      </Button>
    )
  return (
    <Button
      action={action as VoidFunction}
      className="ml-5"
      variant={StyleVariants.ORANGE}
      key={key}
    >
      {text}
    </Button>
  )
}


const PageTitle: React.FC<Props> = ({
  pageTitle,
  buttonText,
  buttonHref,
  hasButtonPermission = false,
  secondaryButton
}: Props): JSX.Element => {
  const renderButtons = (): JSX.Element => {
    if (!buttonText || !buttonHref || !hasButtonPermission) return null
    if (!secondaryButton) {
      return TitleButtonFactory(buttonHref, buttonText, "1")
    } else {
      return (
        <ul className="flex flex-wrap flex-1 justify-left">
          <li>{TitleButtonFactory(buttonHref, buttonText, "1")}</li>
          <li>{secondaryButton}</li>
        </ul>
      )
    }
  }

  return (
    <div className="flex items-center mb-4">
      <h2 className="text-lg py-1">
        {pageTitle}
      </h2>
      {renderButtons()}
    </div>
  )
}

export default PageTitle
